import actions from '../../actions';

import { handleActions } from 'redux-actions';

const initialState = {
  time: 0,
  timePassed: 0,
  timeStarted: 0,
};

const { reset, start, stop } = actions.competition.timingClock;

const computeTimePassed = ({ timePassed, timeStarted }) =>
  timePassed + (timeStarted ? Date.now() - timeStarted : 0);

const reducer = handleActions(
  {
    [reset]: (state, { payload: { time } }) => ({
      ...initialState,
      time,
    }),
    [start]: state => ({
      ...state,
      timeStarted: state.timeStarted || Date.now(),
    }),
    [stop]: state => ({
      ...state,
      timePassed: computeTimePassed(state),
      timeStarted: null,
    }),
  },
  initialState,
);

export default reducer;



// WEBPACK FOOTER //
// ./src/venue/reducers/competition/timingClock.js